<template>
    <div>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item style="float: right">
                <el-button size="small" type="primary" @click="saveDataList()">保存</el-button>
            </el-form-item>
            <el-form-item style="float: right">
                <el-button size="small" @click="currentChangeHandle(1)">刷新列表</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                row-key="id"
                border
                stripe
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%"
        >
            <el-table-column type="selection" fixed width="55"></el-table-column>
            <el-table-column
                    fixed
                    type="index"
                    header-align="left"
                    align="left"
                    label="序号"
                    width="60"
                    :index="getRowsIndex"
            >
            </el-table-column>
            <el-table-column
                    fixed
                    prop="argName"
                    header-align="left"
                    align="left"
                    label="参数名称"
            >
            </el-table-column>
            <el-table-column
                    prop="displayName"
                    header-align="left"
                    align="left"
                    label="显示名称"
            >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.displayName"></el-input>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination> -->
        <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="totalCount"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
        </pagination>  
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination.vue';
    export default {
        components:{Pagination},
        props: {
            formId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                dataForm: {
                    searchKey: "",
                    formId: "",
                },
                datasourceTypeList: [],
                inputTypeList: ['text', 'select', 'datetime', 'number'],
                dataTypeList: [],
                dictCateList: [],
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
                dataList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                dataListLoading: false,
                dataListSelections: [],
            };
        },
        activated() {

        },
        mounted() {
            this.initSelectData()
            this.dataForm.formId = this.formId;
            this.getDataList();
        },
        methods: {
            getHttpReq(url, method = "post", extOps) {
                let ops = {
                    url: url,
                    method: method,
                    baseURL:''
                };
                ops = Object.assign(ops, extOps);
                return this.$http(ops);
            },
            initSelectData() {
                let _self = this;
                this.getHttpReq("/customform/getEnumList/0?required=true", "get").then(({data}) => {
                    _self.datasourceTypeList = this.transformToInt(data);
                });
               /* this.getHttpReq("/sys/dict/getDictCategoryList2", "get").then(({data}) => {
                    _self.dictCateList = data;
                });*/
                this.getHttpReq(this.$http.adornUrl('/customform/getEnumList/1?required=true'), "get").then(({data}) => {
                    _self.dataTypeList = this.transformToInt(data);
                });
            },
            transformToInt(data) {
                let tmp = []
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    element.id = parseInt(element.id)
                    if (isNaN(element.id)) {
                        element.id = 0
                    }
                    tmp.push(element)
                }
                return tmp
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            paginationChange(obj){
                this.pageIndex= obj.page||1
                this.pageSize=obj.limit||10
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                this.$http({
                    url: this.$http.adornUrl("/customform/fromdatasetarg/listSingle"),
                    method: "post",
                    baseURL: '',
                    data: {
                        filter: {
                            formId: this.dataForm.formId,
                        },
                        page: this.pageIndex,
                        rows: this.pageSize,
                        searchKey: this.dataForm.searchKey,
                    },
                }).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows;
                        this.totalCount = data.total;
                        this.pageIndex = data.pageIndex;
                    } else {
                        this.dataList = [];
                        this.totalCount = 0;
                        this.pageIndex = 1;
                    }
                    this.dataListLoading = false;
                });
            },
            saveDataList() {
                this.$http({
                    url: this.$http.adornUrl("/customform/fromdatasetarg/batchUpdate"),
                    method: "post",
                    baseURL: '',
                    data: this.dataList,
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                });
            }
        },
    };
</script>
